import { z } from 'zod';
import { ColumnMappingSchema } from './jobs.js';
/**
 * Request and response envelopes shared by several routes.
 *
 * Split out of contract.ts, which carried the whole API contract in one file.
 * Nothing here changed on the way out.
 */
// ---------- Requests and responses ---------------------------------------------
export const CreateJobResponseSchema = z.object({
    jobId: z.string(),
    name: z.string(),
    encoding: z.string(),
    headers: z.array(z.string()),
    suggestedMapping: ColumnMappingSchema,
    sampleRows: z.array(z.record(z.string(), z.string())),
    rowCount: z.number(),
    warnings: z.array(z.string()),
});
//# sourceMappingURL=requests.js.map